import Config from '../../config';
import AuthEndpoints from './authEndpoints';
import apiClient from '../apiClient';

export const sendVerification = async ({ email }: { email: string }) => {
  const { API_URL } = Config;

  const response = await apiClient.post(
    `${API_URL}${AuthEndpoints.SendVerificationEndpoint}`,
    {
      email,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response.status;
};
